import { UserX } from 'lucide-react';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { LinkStatusCard } from '@/components/common/LinkStatusCard';
import { useLogout } from '@/hooks/useLogout';

interface InviteWrongAccountStateProps {
  /** The email the invite was actually sent to. */
  recipientEmail: string;
}

/**
 * `acceptMethod: 'login'`, but the signed-in session is a different email
 * than the invite's recipient - composes the shared `LinkStatusCard` (same
 * card as `InviteExpiredState`/`WorkEmailRequiredState`), using its
 * `onCtaClick` option to log out instead of navigating.
 */
export function InviteWrongAccountState({ recipientEmail }: InviteWrongAccountStateProps) {
  const I = UI_STRINGS.INVITE_WRONG_ACCOUNT;
  const logout = useLogout();

  return (
    <LinkStatusCard
      icon={<UserX size={32} />}
      heading={I.HEADING}
      body={`${I.BODY_PREFIX}${recipientEmail}${I.BODY_SUFFIX}`}
      ctaLabel={I.CTA}
      onCtaClick={logout}
    />
  );
}
